import { APIURLLEGALES } from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter {
  async fetchDetalleCartaEnviada(idDenuncia) {
    const url = APIURLLEGALES + `/cartas/ObtenerDetalleCartaEnviada?idDenuncia=${idDenuncia || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchCartaEnviadaPdf(idCartaEnviada) {
    const url = APIURLLEGALES + `/cartas/ObtenerPdf?idCartaEnviada=${idCartaEnviada || ''}`
    const response = apiClient.get(url, { isBlob: true })
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter;
